import {BaseModel} from "./base-model";
import {RemoteConfigManager} from "../../third-party-services/remote-config/remote-config-manager";

import {singleton} from "../decorators/singleton";

@singleton
export class BaseRemoteConfiguration extends BaseModel {
  static injectables = [RemoteConfigManager];

  constructor(remoteConfig: RemoteConfigManager) {
    super();

    this.remoteConfig = remoteConfig;

    this.init();
  }

  init() {
    this.remoteConfig.setDefault(this.defaultConfig);
  }

  get defaultConfig() {
    return {}
  }

  getValue(config) {
    let value;

    if(!config) {
      return null;
    }

    if (config.type === REMOTE_CONFIG.KEY_TYPES.boolean) {
      value = this.remoteConfig.getBoolean(config.key);
    } else if (config.type === REMOTE_CONFIG.KEY_TYPES.number) {
      value = this.remoteConfig.getNumber(config.key);
    }  else if (config.type === REMOTE_CONFIG.KEY_TYPES.json) {
      value = this.remoteConfig.getJSON(config.key);
    } else {
      value = this.remoteConfig.getString(config.key);
    }

    return value
  }
}

export const REMOTE_CONFIG = {
  KEY_TYPES: {
    boolean: 1,
    number: 2,
    string: 3,
    json: 4
  }
}
